import { get, download } from '@/api';
import { Attachment } from '@/library/types/files';
import { RawEmail } from 'postal-mime';

export const getFileStream = async (fileId?: string | number) => {
  if (!fileId) return null;

  try {
    const response = await get<RawEmail>(`/files/${fileId}`);

    if (!response) return null;

    return response.data;
  } catch {
    return null;
  }
};

export const getFileMetadata = async (fileId?: string | number) => {
  if (!fileId) return null;

  try {
    const response = await get<Attachment>(`/files-metadata/${fileId}`);

    if (!response) return null;

    return response.data;
  } catch {
    return null;
  }
};

export const renewFilesMetadata = async (files: Attachment[]) => {
  if (!files.length) return null;

  try {
    const response = await get<Attachment[]>(`/files-metadata`);

    if (!response) return files;

    return response.data;
  } catch {
    return files;
  }
};

export const getFileBaseUrl = () => '';

export const isFileSynced = () => ({ is_synced: true, sync_progress: null });

type downloadAllFilesOfEntityType =
  | 'bunker_survey'
  | 'finding'
  | 'note'
  | 'job'
  | 'job_maintenance_details'
  | 'job_flag_extension'
  | 'spare_part'
  | 'email'
  | 'purchasing_supplier_evaluation'
  | 'purchasing_requisition_supplier'
  | 'purchasing_forwarding_case'
  | 'purchasing'
  | 'vessel_document'
  | 'event_lub_oil_analysis_assignment'
  | 'event_office_attachments'
  | 'event_vessel_attachments'
  | 'vetting'
  | 'invoices'
  | 'crew_contract'
  | 'port_document_action_document'
  | 'account_contract';

export const downloadAllFilesOfEntity = async ({
  id,
  type,
  file_type
}: {
  id: number | string;
  type: downloadAllFilesOfEntityType;
  file_type?: string;
}) => {
  try {
    return await download<Attachment[]>(`/files/entity`, { id, type, file_type });
  } catch (error) {
    console.error(error);
  }
};
